// @flow

import CollapseButtonComponent from '../components/CollapseButtonComponent';

export default class FilterCollapseButton extends CollapseButtonComponent {
  #icon: HTMLElement;
  #closeIcon: string = '#icon-minus';
  #openIcon: string = '#icon-plus';

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.class = 'md:hidden';

    const icon: HTMLElement | null = pEl.querySelector('[ref="collapse-icon"]');
    if (icon) {
      this.#icon = icon;
    } else {
      throw new Error('A collapse icon is required');
    }
  }

  /**
   * Executes when the user clicks on the button
   */
  handleClick(e: Event): void {
    super.handleClick(e);

    const activeHref: string = this.#icon.firstElementChild.getAttribute('href');
    if (activeHref === this.#closeIcon) {
      this.#icon.firstElementChild.setAttribute('href', this.#openIcon);
    } else {
      this.#icon.firstElementChild.setAttribute('href', this.#closeIcon);
    }
  }
}
